import React from "react";

export const ContactSales = ({ refe }) => {
  const handleClick = () => {
    window.location.href = "https://calendly.com/teamclinqo/30min";
  };

  return (
    // This is the contact sales section
    <div
      ref={refe}
      className="bg-black flex flex-col justify-center items-center px-10 py-20 gap-10 text-blue-500"
    >
      <h1 className="text-5xl text-white font-bold">"Just Clinq it"</h1>
      {/* // This is the title */}
      <h2 className="text-4xl font-semibold"> Contact Sales</h2>

      {/* // This is the Button */}
      <button
        onClick={handleClick}
        className="text-xl bg-gradient-to-br from-[#132893] to-[#2162DE] font-semibold px-10 py-3 text-white"
      >
        Book an Appointment
      </button>
    </div>
  );
};
